// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"23":"bda159bb","216":"44b0dbd9","263":"e42e067a","340":"041f207b","405":"67456d91"}[chunkId] + ".css";
};